import React from "react";
import Footer from "../components/footer";

const PrivacyPage = () => (
  <div className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black text-gray-200 px-6 py-12">
        <div className="max-w-5xl mx-auto">
            <h1 className="text-3xl font-bold mb-6 text-green-400">Privacy Policy</h1>
            <p className="mb-4">We are committed to protecting your privacy. This policy outlines how we collect, use, and safeguard your personal information.</p>
            <h2 className="text-xl font-semibold text-white mt-6 mb-2">Information Collection</h2>
            <p className="mb-4">We collect personal information you provide when signing up, contacting us, or using our services.</p>
            <h2 className="text-xl font-semibold text-white mt-6 mb-2">Use of Information</h2>
            <p className="mb-4">Your information is used to provide and improve our services, process transactions, and send relevant updates.</p>
            <h2 className="text-xl font-semibold text-white mt-6 mb-2">Data Protection</h2>
            <p className="mb-4">We implement security measures to protect your data from unauthorized access, disclosure, or misuse.</p>
            <p className="mt-8 text-sm text-gray-400">Last updated: June 16, 2025</p>
        </div>
    </div>
);

export default PrivacyPage;